module.exports = __webpack_public_path__ + "static/media/finance.a8197933.png";